import { ACTIVATE_USER, ACTIVATE_USER_DONE, ACTIVATE_USER_ERR, RESET_USER_ACTIVATION } from './actionTypes';
import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
const initialState = Object.assign({}, defaultInitialState);
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIVATE_USER:
            return Object.assign(Object.assign({}, state), loadingState);
        case ACTIVATE_USER_DONE:
            return Object.assign(Object.assign({}, state), updatedState);
        case ACTIVATE_USER_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case RESET_USER_ACTIVATION:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map